import type { OptimisticMessage } from "@/lib/types/channel";

type CurrentMemberInfo = {
  id: string;
  role: string;
  displayName: string | null;
  image: string | null;
};

export function makeOptimisticMessage(
  content: string,
  parentId: string | null,
  currentMember: CurrentMemberInfo,
): OptimisticMessage {
  const now = new Date().toISOString();
  return {
    id: `optimistic-${Date.now()}-${Math.random()}`,
    createdAt: now,
    updatedAt: now,
    content,
    contentJson: null,
    editedAt: null,
    deletedAt: null,
    parentId,
    member: {
      id: currentMember.id,
      role: currentMember.role as OptimisticMessage["member"]["role"],
      profile: {
        displayName: currentMember.displayName,
        image: currentMember.image,
      },
    },
    reactions: [],
    _count: { replies: 0 },
    optimisticStatus: "sending",
  };
}
